import React, { Fragment } from 'react';
import Footer from '../../component/Other/Footer';
import Navbar from '../../component/Other/Navbar';

const GraciasPago = () => {
  return (
    <Fragment>
      <div className="overflow-hidden font-poppins">
        <div className="bg__blue-2">
          <Navbar />
          <section className="position-relative py-5">
            <div className="container text-center">
              <div className="mb-4">
                <span style={{ fontSize: '64px' }}>✅</span>
              </div>
              <h1 className="semi-bold font__size--36 text__32-1024 text__32-md text__32-sm mb-4" style={{ color: '#626475' }}>
                ¡Gracias por pagar!
              </h1>
              <p className="medium font__size--18 text__18-1024 lh-2 mb-3" style={{ maxWidth: '500px', margin: '0 auto', color: '#626475' }}>
                Tu pago fue recibido. Tu plan se activará automáticamente en la app ListoPago en los próximos minutos.
              </p>
              <p className="medium font__size--14 text__14-1024 lh-2" style={{ maxWidth: '500px', margin: '0 auto', color: '#626475' }}>
                Asegúrate de iniciar sesión en la app con el mismo correo que usaste para pagar.
              </p>
            </div>
          </section>
        </div>
        <img src="./../images/Subtract.png" className="w-100 img-cover" alt="" />
        <section className="py-5">
          <div className="container text-center">
            <p className="medium font__size--16 text__16-1024 lh-2 mb-0" style={{ color: '#626475' }}>
              Si tienes alguna duda, contáctanos por WhatsApp o correo.
            </p>
          </div>
        </section>
        <Footer />
      </div>
    </Fragment>
  );
};

export default GraciasPago;
